import { render } from "./coverageComponent.vue?vue&type=template&id=01490c2a&ts=true"
import script from "./coverageComponent.ts?vue&type=script&lang=ts"
export * from "./coverageComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__